/**
 * 共用顯示標籤（SSOT）
 * 預繳名單性別等，可與 i18n 對齊
 */

/** 性別顯示名稱（預繳名單等） */
export const GENDER_LABELS: Record<string, string> = {
  male: '男',
  female: '女',
  other: '其他',
};
